import { FileAttachmentIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Delete01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { Card } from "shared/components/Card";
import { Loader } from "shared/components/Loader";

export interface PendingAttachment {
  id: string;
  file: File;
  status: "uploading" | "uploaded" | "error";
  uploadUrl?: string;
}

export const NoteAttachmentCard = ({
  attachment,
  onRemove
}: {
  attachment: PendingAttachment;
  onRemove: (id: string) => void;
}) => {
  return (
    <Card className="w-[300px] flex items-center gap-3 px-4 py-3">
      <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary-20">
        <HugeiconsIcon
          icon={FileAttachmentIcon}
          size={20}
          strokeWidth={1.5}
          className="text-primary-500"
        />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-bold text-content-1000">
          {attachment.file.name}
        </p>
        <p className="text-xs text-content-200">
          {attachment.status === "uploading" && "Uploading..."}
          {attachment.status === "error" && "Upload failed"}
          {attachment.status === "uploaded" && "Uploaded"}
        </p>
      </div>
      {attachment.status === "uploading" ? (
        <Loader size={16} />
      ) : (
        <IconButton
          variant={IconButtonVariant.BASE}
          size={IconButtonSize.XS}
          HugeIcon={Delete01Icon}
          onClick={() => onRemove(attachment.id)}
        />
      )}
    </Card>
  );
};
